<template>
    <header class="siteheader sticky-top">
        <div class="siteheader__container opCookies-header">
            <LogoTextTransition v-if="isMobile" key="logo-text"/>
            <LogoText v-if="!isMobile"/>
            <RollTextButton v-if="scrolled && ( button_type === 'roll-text')" key="roll-button" ref="rollButton"
                            :firstline="'Profitez de l’offre temporaire'" :secondline="'Recevez un cadeau GRATUIT'"/>
            <b-button v-else key="static-button" ref="staticButton"
                      class="button is-primary next-button opcookies-button"
                      @click="nextStep()">
                Profitez de l’offre
            </b-button>
        </div>
    </header>
</template>

<script>
import LogoTextTransition from "../_commons/fr/LogoTextTransition.vue";
import LogoText from "../_commons/fr/LogoText.vue";
import RollTextButton from "./RollTextButton.vue";
import LogoBullet from "../_commons/fr/LogoBullet.vue";
import mixin from "../../components/form/steps/travel_step_mixin";
import image_mixin from "../_commons/fr/mixins/image_mixin";
import {gsap} from "gsap";

export default {
    mixins: [mixin, image_mixin],
    components: {LogoBullet, LogoTextTransition, RollTextButton, LogoText},
    computed: {
        formUrl() {
            return `${location.origin}/${window.slug}`
        },
        isMobile() {
            return window.innerWidth <= 768;
        },
    },
    data() {
        return {
            scrolled: false,
            animatingOut: false,

        };
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll);
    },

    beforeUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll() {
            const atTop = window.scrollY < 70;

            // Scrolling down → show and animate in
            if (!this.scrolled && !atTop) {
                this.scrolled = true;

                this.$nextTick(() => {
                    const el = this.$refs.rollButton?.$el;
                    if (el) {
                        gsap.fromTo(el, {opacity: 1, scaleX: 0.7}, {
                            opacity: 1,
                            scaleX: 1,
                            transformOrigin: "right",
                            duration: 0.4,
                            ease: "power2.out"
                        });
                    }
                });
            }

            // Scrolling up to top → animate out before hiding
            if (this.scrolled && atTop && this.button_type === "roll-text") {
                const el = this.$refs.rollButton?.$el;
                if (el && !this.animatingOut) {
                    this.animatingOut = true;

                    gsap.to(el, {
                        opacity: 1,
                        scaleX: this.isMobile ? 0.6 : 0.9,
                        transformOrigin: "right",
                        duration: 0.3,
                        ease: "power2.in",
                        onComplete: () => {
                            this.scrolled = false;
                            this.animatingOut = false;
                        }
                    });
                }
            }
        }
    }
};
</script>


